import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';

import CloseIcon from '@material-ui/icons/Close';
import { Button, makeStyles, Paper, Tab, Tabs } from '@material-ui/core';

import formStyles from 'utils/formStyles';

import Dialog from 'components/RMSDialog';
import AddPlace from 'components/RMSRecordsDialogs/PlaceEdit/AddPlace';
import PlaceSops from 'components/RMSRecordsDialogs/PlaceEdit/PlaceSops';
import PlaceAddress from 'components/RMSRecordsDialogs/PlaceEdit/PlaceAddress';
import PlaceContact from 'components/RMSRecordsDialogs/PlaceEdit/PlaceContact';
import PlaceVehicles from 'components/RMSRecordsDialogs/PlaceEdit/PlaceVehicles';
import PlaceEmployees from 'components/RMSRecordsDialogs/PlaceEdit/PlaceEmployees';

import { handleError } from 'reducers/ErrorReducer';
import { getPtsPlace, getPeopleSops } from 'reducers/SearchReducer';
import { showSpinner, hideSpinner } from 'reducers/UiReducer';
import { closeEditPlace } from 'reducers/PersonDialogsReducer';
import { getFullPermissions } from 'reducers/PermissionsReducer';

const useStyles = makeStyles((theme) => ({
  ...formStyles,
  wrap: {
    padding: theme.spacing(3),
  },
  content: {
    margin: -theme.spacing(3),
  },
  RedTabs: {
    color : 'red'
  }
}));

function PlaceAdd(props) {
  const classes = useStyles();
  const { ptsPlaceID, ptsAddressID } = props;

  const [rowData, setRowData] = useState([]);
  const [addressData, setAddressData] = useState([]);
  const [contactInfo, setContactInfo] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [needRefresh, setNeedRefresh] = useState(false);
  const [tab, setTab] = useState('edit');
  const [canSave, setCanSave] = useState(false);
  const placesPermission = getFullPermissions('globals', 'Places', 'any');
  const mountedRef = useRef(true);
  const [countOfSops, setCountOfSops] = useState(0);

  const addPlace = ptsPlaceID === true;
  const newPlace = !ptsPlaceID || ptsPlaceID === true;
  useEffect(() => {
    if (newPlace) {
      setCanSave(true);
    } else {
      if (placesPermission.Edit) {
        setCanSave(true);
      } else {
        setCanSave(false);
      }
      getSOPs();
    }
  }, [newPlace]);
  useEffect(() => {
    if (props.tab) setTab(props.tab);
    return () => {
      mountedRef.current = false;
    };
  }, [props.tab]);

  useEffect(() => {
    if (!ptsPlaceID || ptsPlaceID === true) return;
    getPlace();
  }, [ptsPlaceID, needRefresh]);

  const getPlace = () => {
    props.showSpinner();
    getPtsPlace(ptsPlaceID).then(processData).catch(props.handleError).finally(props.hideSpinner);
  };

  const getSOPs = async () => {
    try {
      const sops = await getPeopleSops(ptsPlaceID, 'Place');
      if (!mountedRef.current) return;
      setCountOfSops(sops.data.length);
    } catch (err) {
      props.handleError(err, 'Error receiving place sop data.');
    }
  };
  
  const handleSOPChange = (newCount) => {
    setCountOfSops(newCount);
  };

  const processData = (data) => {
    const { PlaceAddress, Employement, ContactInfo } = data;
    const add = PlaceAddress?.map((pa) => {
      return {
        ...pa.Address,
        ...pa,
        City: pa.Address.City?.CityDescription || '',
      };
    });
    const emp = Employement?.map((employee) => {
      return { ...employee, ...employee.PersonInfo };
    });
    setEmployees(emp || []);
    setContactInfo(ContactInfo || []);
    setAddressData(add || []);
    setRowData(data);
  };

  const renderActions = () => {
    return (
      <div className={classes.dialogActions}>
        <Button color="primary" onClick={close}>
          <CloseIcon /> Close
        </Button>
      </div>
    );
  };

  const close = () => {
    props.closeEditPlace();
  };
  const getTitle = () => {
    const title = newPlace ? 'Add Places' : 'Edit Places';
    return newPlace || placesPermission.Edit ? (
      `${title}`
    ) : (
      <div className="d-flex" style={{ width: '100%', justifyContent: 'left', textAlign: 'left' }}>
        <span style={{ flex: 0.5 }}>{title}</span>
        <span style={{ flex: 0.5, color: 'red', fontWeight: 'bold', fontSize: '21px' }}>
          VIEW ONLY MODE
        </span>
      </div>
    );
  };
  return (
    <Dialog toolbar onClose={close} actions={renderActions()} title={getTitle()} fullScreen>
      <div className={classes.content}>
        <Paper square>
          <Tabs value={tab} onChange={(ev, val) => setTab(val)}>
            <Tab label="Place" value="edit" />
            <Tab label="Address" value="address" disabled={newPlace} />
            <Tab label="Contact" value="contact" disabled={newPlace} />
            <Tab label="Employees" value="employee" disabled={newPlace} />
            <Tab label={countOfSops > 0 ? `SOPs (${countOfSops})` : 'SOPs'} value="sop" disabled={newPlace} 
                 className={countOfSops > 0 ? classes.RedTabs : ''}/>
            <Tab label="Vehicle Registrations" value="vehicles" disabled={newPlace} />
            {/* <Tab label="Coordinates" value="coordinates" /> */}
          </Tabs>
        </Paper>
        {tab === 'edit' && (
          <AddPlace
            close={close}
            ptsPlaceID={ptsPlaceID}
            canSave={canSave}
            rowData={rowData}
            ptsAddressID={ptsAddressID}
          />
        )}
        {tab === 'address' && (
          <PlaceAddress
            needRefresh={needRefresh}
            setNeedRefresh={setNeedRefresh}
            close={close}
            ptsPlaceID={ptsPlaceID}
            canSave={canSave}
            addressData={addressData}
          />
        )}
        {tab === 'contact' && (
          <PlaceContact
            close={close}
            ptsPlaceID={ptsPlaceID}
            canSave={canSave}
            contactInfo={contactInfo}
          />
        )}
        {tab === 'employee' && (
          <PlaceEmployees
            close={close}
            ptsPlaceID={ptsPlaceID}
            canSave={canSave}
            employees={employees}
          />
        )}
        {tab === 'sop' && <PlaceSops close={close} ptsPlaceID={ptsPlaceID} canSave={canSave} onSOPChange={handleSOPChange} />}
        {tab === 'vehicles' && (
          <PlaceVehicles close={close} ptsPlaceID={ptsPlaceID} canSave={canSave} />
        )}
        {/* {tab === 'parties' && <AddressParties ptsAddressID={ptsAddressID} />} */}
      </div>
    </Dialog>
  );
}

export default connect(null, {
  closeEditPlace,
  handleError,
  showSpinner,
  hideSpinner,
})(PlaceAdd);
